import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  signupRequest: ['history'],
  signupSuccess: null,
  signupFailure: ['error'],
  emailChanged: ['email'],
  confirmEmailChanged: ['confirmEmail'],
  passwordChanged: ['password'],
  confirmPasswordChanged: ['confirmPassword'],
  clearSignupError: null,
});

export const SignupTypes = Types;
export default Creators;



// WEBPACK FOOTER //
// ./src/state/actions/SignupActions.js